import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/site/Seo";
import { Container } from "../components/site/Ui";
import { useLang } from "../lib/LangContext";


export default function NotFound() {
  const { tr } = useLang();
  return (
    <>
      <Seo title="Page not found" description="This page could not be found." path="/404" />
      <Container className="flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
        <p className="font-display text-6xl font-extrabold text-[#F95738]">404</p>
        <h1 className="mt-4 text-3xl font-bold text-slate-900">{tr("This page doesn't exist.")}</h1>
        <p className="mt-3 max-w-md text-sm text-slate-600">
          {tr("The link may be out of date. Head back to the homepage or take a look at the pricing.")}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link to="/" data-testid="notfound-home-link" className="rounded-full bg-[#F95738] px-6 py-3.5 text-base font-semibold text-white">
            {tr("Back to Home")}
          </Link>
          <Link to="/pricing" data-testid="notfound-pricing-link" className="rounded-full border border-slate-300 px-6 py-3.5 text-base font-semibold text-slate-800">
            {tr("See Pricing")}
          </Link>
        </div>
      </Container>
    </>
  );
}
